"use client";

import { Box, Typography } from "@mui/material";
import { theme } from "@/lib/theme";
import Image from "next/image";

export const Footer = () => {
  return (
    <Box
      sx={{
        background: `linear-gradient(to bottom, ${theme.colors.lightPurple} 0%, ${theme.colors.lightPurple} 70%, ${theme.colors.purple} 100%)`,
        marginTop: {
          xs: "64px",
          sm: "96px",
        },
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingTop: {
          xs: "24px",
          sm: "32px",
        },
        paddingBottom: {
          xs: "24px",
          sm: "32px",
        },
        paddingLeft: {
          xs: "24px",
          sm: "32px",
        },
        paddingRight: {
          xs: "24px",
          sm: "32px",
        },
      }}
    >
      <Box
        sx={{
          maxWidth: theme.containerWidth.content,
          margin: "0 auto",
          display: "flex",
          flexDirection: {
            xs: "column",
            sm: "row",
          },
          alignItems: "center",
          gap: {
            xs: 3,
            sm: 4,
          },
        }}
      >
        <Image
          src="/images/convocation-logo.svg"
          alt="Convocation Research + Design"
          width={200}
          height={50}
        />
        <Typography
          variant="body1"
          sx={{
            marginTop: 3,
            marginBottom: 0,
          }}
        >
          Like this article and want to support more work like this? Learn more about Convocation
          Research + Design{" "}
          <a href="https://convocation.design" target="_blank" rel="noopener noreferrer">
            here
          </a>
          .
        </Typography>
      </Box>
    </Box>
  );
};
